import React, { useEffect, useState } from 'react'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServiceInner from '../Components/Services/ServiceInner'
import ScrollToTop from '../Components/ScrollToTop'
import { apiUrl } from '../Constants/contant'
import { useParams } from 'react-router-dom'

function Service() {
    const id = useParams();

       const [services, setService] = useState([]);
       const [category, setCategory] = useState([]);
      
    
    useEffect(() => {
      fetch(apiUrl + `services/${id?.id}`)
        .then(response => response.json()) 
        .then(data => {
          setService(data.services);
          setCategory(data.category);
        
        })
        .catch(error => {
          console.error("There was an error fetching sliders!", error);
        });
    }, [id]);

    return (
        <div>
            <Breadcrumb title="Services" category={category}/>
            <ServiceInner services={services}/>
            <ScrollToTop />
            
        </div>
    )
}

export default Service
